<template>
  <div class="py-4 container-fluid">
    <!-- STATS CARDS -->
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Total SMS"
          :value="stats.total"
          :icon="{
            component: 'ni ni-paper-diploma',
            background: 'bg-gradient-primary',
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Envíos Exitosos"
          :value="stats.success"
          :icon="{
            component: 'ni ni-check-bold',
            background: 'bg-gradient-success',
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Errores"
          :value="stats.error"
          :icon="{
            component: 'ni ni-fat-remove',
            background: 'bg-gradient-danger',
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Balance Disponible"
          :value="balance || '0.00 USD'"
          :icon="{
            component: 'ni ni-money-coins',
            background: 'bg-gradient-warning',
          }"
          direction-reverse
        />
      </div>
    </div>

    <!-- CHART -->
    <div class="row mt-4">
      <div class="col-lg-7 mb-lg-0 mb-4">
        <div class="card z-index-2">
          <div class="card-body p-3">
            <gradient-line-chart
              v-if="renderChart"
              id="chart-line"
              title="Actividad de Envíos"
              description="Mensajes enviados en los últimos 7 días"
              :chart="chartData"
            />
            <div v-else class="text-center py-5">
              <p class="text-muted">Cargando gráfico...</p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- RECENT ACTIVITY -->
      <div class="col-lg-5">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>Actividad Reciente</h6>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Destino</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sms in recentSms" :key="sms._id">
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{ sms.to }}</p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="sms.response.status === 'success' ? 'bg-gradient-success' : 'bg-gradient-danger'">
                        {{ sms.response.status === 'success' ? 'OK' : 'FAIL' }}
                      </span>
                    </td>
                    <td>
                      <span class="text-secondary text-xs font-weight-bold">{{ formatDate(sms.created_at) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="recentSms.length === 0" class="text-center py-4">
                <p class="text-xs text-muted">No hay envíos recientes</p>
              </div>
            </div>
            <div class="text-center mt-3">
              <router-link :to="{ name: 'sms-list' }" class="btn btn-link text-primary text-xs mb-0">Ver todo el historial</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import { get } from "@/utils/httpRequest";

export default {
  name: "DashboardSMS",
  components: {
    MiniStatisticsCard,
    GradientLineChart,
  },
  data: () => ({
    stats: {
      total: 0,
      success: 0,
      error: 0
    },
    balance: null,
    chartData: null,
    recentSms: [],
    renderChart: false
  }),
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        // 1. Get stats and chart data
        const { data: report } = await get("sms/get-report");
        if (report) {
          this.stats.total = report.total;
          this.stats.success = report.success;
          this.stats.error = report.error;
          this.chartData = report.chart;
          this.renderChart = true;
        }

        // 2. Get balance
        const { data: balanceData } = await get("sms/get-zadarma-balance");
        if (balanceData && balanceData.balance !== undefined) {
          this.balance = `${balanceData.balance} ${balanceData.currency || 'USD'}`;
        }

        // 3. Get recent activity
        const { data: listData } = await get("sms/find-all-sms?limit=5&page=1");
        if (listData && listData.docs) {
          this.recentSms = listData.docs;
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getDate()}/${d.getMonth() + 1} ${d.getHours()}:${d.getMinutes()}`;
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 1rem;
}
.badge {
  text-transform: uppercase;
}
</style>
